import { c as _c } from "react/compiler-runtime";
import { FontWeights, Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { useInfoBarSingleRowFrom } from "@components/common/info-bar/info-bar-layout-context";
import { CommonStyles } from "@styles/common-styles";
import { useId } from "react";

/** Look of an item's label, also applied to the label a dropdown in the item brings along */
const LABEL_SX = {
  fontSize: "0.75rem",
  lineHeight: "1.25rem",
  fontWeight: FontWeights.Regular,
  color: "text.secondary"
};
/** A labelled item of the info bar: a small label above its value. */
export function InfoBarItem(t0) {
  const $ = _c(24);
  const {
    label,
    isFlexible: t1,
    children
  } = t0;
  const isFlexible = t1 === undefined ? false : t1;
  const labelId = useId();
  const singleRowFrom = useInfoBarSingleRowFrom();
  const t2 = label ? labelId : undefined;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      xs: 1.5,
      sm: 0
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== isFlexible || $[2] !== singleRowFrom) {
    t4 = isFlexible ? {
      xs: "0 0 auto",
      sm: "1 1 40%",
      [singleRowFrom]: "1 1 auto"
    } : "0 1 auto";
    $[1] = isFlexible;
    $[2] = singleRowFrom;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isFlexible ? 0 : "auto";
  const t6 = isFlexible ? undefined : "nowrap";
  let t7;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      height: "1.625rem",
      lineHeight: "1.625rem",
      paddingTop: "1px",
      paddingBottom: "3px"
    };
    t8 = {
      boxShadow: "none"
    };
    $[4] = t7;
    $[5] = t8;
  } else {
    t7 = $[4];
    t8 = $[5];
  }
  let t10;
  let t11;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      xs: CommonStyles.Borders.divider,
      sm: "none"
    };
    t10 = {
      xs: "none",
      sm: CommonStyles.Borders.divider
    };
    t11 = {
      xs: 0,
      sm: "-1px"
    };
    $[6] = t10;
    $[7] = t11;
    $[8] = t9;
  } else {
    t10 = $[6];
    t11 = $[7];
    t9 = $[8];
  }
  let t12;
  if ($[9] !== singleRowFrom) {
    t12 = {
      borderTop: "none",
      borderLeft: {
        [singleRowFrom]: "none"
      }
    };
    $[9] = singleRowFrom;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== t12 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t13 = {
      px: 2.5,
      py: t3,
      flex: t4,
      minWidth: t5,
      whiteSpace: t6,
      maxWidth: "100%",
      "& .MuiInputBase-root .MuiInputBase-input": t7,
      "& [role=combobox]:not(:hover)": t8,
      "& :has(+ [role=combobox]) .MuiTypography-root": LABEL_SX,
      borderTop: t9,
      borderLeft: t10,
      ml: t11,
      "&:first-of-type": t12
    };
    $[11] = t12;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== label || $[17] !== labelId) {
    t14 = label && <Text id={labelId} variant="bodyM" shouldElide={true} sx={{
      display: "block",
      ...LABEL_SX
    }}>{label}</Text>;
    $[16] = label;
    $[17] = labelId;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== children || $[20] !== t13 || $[21] !== t14 || $[22] !== t2) {
    t15 = <Box role="group" aria-labelledby={t2} sx={t13}>{t14}{children}</Box>;
    $[19] = children;
    $[20] = t13;
    $[21] = t14;
    $[22] = t2;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  return t15;
}